/**
 * User: Joe Forzano
 * Date: August 20th, 2014
 * Time: 3:15 PM
 */
"use strict";

// ---------------------------------------------------
// Load Module Super PseudoClass

var SoaModel = require('bunsen/models/SoaModel');


// ---------------------------------------------------
// Module Definition
/**
 * @class Carrier
 * @extends SoaModel
 */
var Carrier = module.exports = SoaModel.extend();


// ---------------------------------------------------
// Dependencies

var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var Backbone = require('dibs-backbone');
var Carriers = require('bunsen/collections/logistics/Carriers');
var ServiceMethod = require('bunsen/models/logistics/ServiceMethod');


// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Carrier.prototype, {

    url: endpoints.carrier(),

    relations: SoaModel.createRelations([
        {
            type : Backbone.Many,
            key : 'shipmentServiceMethods',
            relatedModel : ServiceMethod
        }
    ]),

    /**
     * Returns the defaults service method for the carrier. As of now, there's only one service method, but
     * if multiple service methods are attached to a carrier in the future, the logic for selecting the default
     * should be housed here.
     * @returns {object} -- ServiceMethod
     */
    getDefaultShipmentServiceMethod: function () {
        return this.get('shipmentServiceMethods').first();
    },

    /**
     * Returns the name on the carrier model, or if that isn't defined, returns the name
     * associated with the carrier's id (looked up on currently fetched carriers)
     * @returns {string}
     */
    getCarrierName: function () {
        return this.get('name') || Carriers.getCarrierName(this.get('id'));
    },

    /**
     * @returns {string}
     */
    describeCarrierName: function () {
        var name = this.getCarrierName();
        if (this.isOtherCarrier() && !this.carrierNameIsOther()) {
            return 'Other - ' + name;
        }
        return name;
    },

    /**
     * Return true if carrier name is "other". This is to avoid
     * redundancy.
     * @returns {string|boolean}
     */
    carrierNameIsOther: function () {
        var name = this.getCarrierName();
        return name && name.toLowerCase() === Carrier.CARRIER_NAME_OTHER;
    },

    /**
     * Returns true when the carrier code is OTHER
     * @returns {boolean}
     */
    isOtherCarrier: function () {
        return this.get('code') === Carrier.CARRIER_CODE_OTHER;
    }

});

_.extend(Carrier, /** @lends Carrier */{
    CARRIER_CODE_OTHER: 'OTHER',
    CARRIER_NAME_OTHER: 'other'
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/logistics/Carrier.js
// module id = 315
// module chunks = 62